import { render, staticRenderFns } from "./AppointmentCoordinationWrapper.vue?vue&type=template&id=da79fbb6"
import script from "./AppointmentCoordinationWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentCoordinationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports